import api from '~/services/api';
import { formDataProps, rowProps, tiposProps } from '../types';

const getTiposdeEstoque = async (): Promise<{
  rowsPais: tiposProps[];
  rowsFilhos: tiposProps[];
  success: boolean;
}> => {
  const { data } = await api.get('/tipoajusteestoque/tipos-ajustes');
  return data;
};

const getProductsProd = async (
  cod_produto: string,
  cod_loja: number,
): Promise<{
  data: rowProps[];
  success: boolean;
}> => {
  const { data } = await api.get(
    `/movimento-producao/${cod_produto}/${cod_loja}`,
  );
  return data;
};

const getProducao = async (
  cod_seq_producao: number,
): Promise<{
  data: rowProps[];
  success: boolean;
}> => {
  const { data } = await api.get(`/movimento-producao/${cod_seq_producao}`);
  return data;
};

const createProduction = async (
  formData: formDataProps,
): Promise<{
  success: boolean;
  message: string;
}> => {
  const { data } = await api.post(`/movimento-producao`, formData);
  return data;
};

const cancelProduction = async (
  cod_seq_producao: number,
): Promise<{
  success: boolean;
  message: string;
}> => {
  const { data } = await api.put(`/movimento-producao/${cod_seq_producao}`);
  return data;
};

export const servicesMovProd = {
  getTiposdeEstoque,
  getProductsProd,
  getProducao,
  createProduction,
  cancelProduction,
};
